import combinatorics from '../../../helpers/combinatorics'
import {_11x5Alias, pk10Alias, jssmAlias, _3dAlias, sscAlias, k3Alias} from './recentlyCodesForm/rule-recentCode-mathch'
/**
 * 进入最后返回前的后处理
 * 优先级最低，权重区间 10000 - 6000 步长100
 */
export default function After(R){
  return [
    {
      // 竞速PK类型格式化最后显示号码
      // 去掉空数组
      priority: 9000,
      condition: function(R) {
            R.when(  this.lotteryType === 'ssc' && this.currentMethod.selectarea.type == 'pk' )
        },
      consequence: function(R) {
        this.displayCodes = [];
        _.each(this.formatCodes, function(item){
          if (item.length == 2) {
            this.displayCodes.push(_.join(item, 'vs'));
          }else{
            this.displayCodes.push('X');
          }
        }.bind(this))
        this.displayCodes = _.join(this.displayCodes, ',')
        // 去掉空数组
        this.formatCodes = _.filter(this.formatCodes, (item) => item.length == 2)
          R.next();
      }
    },
    // 任选复式玩法单独标识单挑
    {
      priority: 8950,
      condition: function(R) {
            R.when(  _.includes(this.ruleSuite, 'any-solo') && this.num > 0 )
        },
      consequence: function(R) {
        // 选中了几个位置的号码
        const poschoose = _.filter(this.formatCodes, (item) => item.length > 0).length;
        // 任选N
        switch(this.attached.number){
          case 2:{
            if (poschoose == 2 && this.minNumber <= 1) {
              this.solo = true;
            }
            if (poschoose == 3 && this.minNumber <= 3) {
              this.solo = true;
            }
            if (poschoose == 4 && this.minNumber <= 6) {
              this.solo = true;
            }
            if (poschoose == 5 && this.minNumber <= 10) {
              this.solo = true;
            }
            break;
          }
          case 3:{
            if (poschoose == 3 && this.minNumber <= 10) {
              this.solo = true;
            }
            if (poschoose == 4 && this.minNumber <= 40) {
              this.solo = true;
            }
            if (poschoose == 5 && this.minNumber <= 100) {
              this.solo = true;
            }
            break;
          }
          case 4:{
            if (poschoose == 4 && this.minNumber <= 100) {
              this.solo = true;
            }
            if (poschoose == 5 && this.minNumber <= 500) {
              this.solo = true;
            }
            break;
          }
        }
        R.next();
      }
    },
    {
      // 该注单是不是单挑标识
      priority: 8900,
      condition: function(R) {
            R.when(  this.lotteryType === 'ssc' && !_.includes(this.ruleSuite, 'any-solo') )
        },
      consequence: function(R) {
        let positionLength = 0
        if(this.bet.poschoose){
          _.forEach(this.bet.poschoose, function(item){
            if(item){
              positionLength ++
            }
          })
        }else{
          _.forEach(this.formatCodes, function(item){
            if(item.length>0){
              positionLength ++
            }
          })
        }
        const methodName = _.trim(this.currentCategory.name + this.currentMethod.name);
        const lotteryAlias = this.currentCategory.flag;
        // 时时彩彩种
        if (_.includes(sscAlias, lotteryAlias)) {
          switch(methodName){
            case '五星单式':
            case '五星复式':{
              if (this.num <= 1000) {
                this.solo = true;
              }
              break;
            }
            case '五星组合':{
              if(this.num<=5000){
                this.solo = true;
              }
              break;
            }
            case '四星单式':
            case '四星复式':{
              if (this.num <= 100) {
                this.solo = true;
              }
              break;
            }
            case '四星组合':{
              if(this.num<=400){
                this.solo = true;
              }
              break;
            }
            case '四星组选24':{
              if(this.num<=5){
                this.solo = true;
              }
              break;
            }
            case '前三码单式':
            case '中三码单式':
            case '后三码单式':
            case '前三码直选单式':
            case '中三码直选单式':
            case '后三码直选单式':
            case '前三码直选和值':
            case '中三码直选和值':
            case '后三码直选和值':
            case '前三码复式':
            case '中三码复式':
            case '后三码复式':
            case '前三码直选复式':
            case '中三码直选复式':
            case '后三码直选复式':
            {
              if(this.num<=10){
                this.solo = true;
              }
              break;
            }
            case '前三码组三':
            case '中三码组三':
            case '后三码组三':
            case '前三码组六':
            case '中三码组六':
            case '后三码组六':
            case '前三码混合组选':
            case '中三码混合组选':
            case '后三码混合组选':
            case '前三码混合':
            case '中三码混合':
            case '后三码混合':
            {
              if(this.num<=1){
                this.solo = true;
              }
              break;
            }
            case '前三码组选和值':
            case '中三码组选和值':
            case '后三码组选和值':
            {
              if(this.num<=2){
                this.solo = true;
              }
              break;
            }
            case '二码后二直选(复式)':
            case '二码后二组选(复式)':
            case '二码前二直选(复式)':
            case '二码前二组选(复式)':
            case '二码中二直选(复式)':
            case '二码中二组选(复式)':
            case '二码后二直选(单式)':
            case '二码后二组选(单式)':
            case '二码中二直选(单式)':
            case '二码中二组选(单式)':
            case '二码前二直选(单式)':
            case '二码前二组选(单式)':
            case '二码后二直选复式':
            case '二码后二组选复式':
            case '二码前二直选复式':
            case '二码前二组选复式':
            case '二码中二直选复式':
            case '二码中二组选复式':
            case '二码后二直选单式':
            case '二码后二组选单式':
            case '二码中二直选单式':
            case '二码中二组选单式':
            case '二码前二直选单式':
            case '二码前二组选单式':
            case '二码后二直选和值':
            case '二码前二直选和值':
            case '二码后二组选和值':
            case '二码前二组选和值':
            {
              if(this.num<=1){
                this.solo = true;
              }
              break;
            }
            case '任选二直选复式':
            case '任选二直选单式':
            case '任选二直选和值':
            case '任选二组选复式':
            case '任选二组选单式':
            case '任选二组选和值':
            {
              if(positionLength == 2 && this.num<=1){
                this.solo = true;

              }
              if(positionLength == 3 && this.num <=3){
                this.solo = true;
              }
              if(positionLength == 4 && this.num <=6){
                this.solo = true;
              }
              if(positionLength == 5 && this.num <= 10){
                this.solo = true;
              }
              break;
            }
            case '任选三直选复式':
            case '任选三直选单式':
            case '任选三直选和值':
            {
              if(positionLength == 3 && this.num <=10){
                this.solo = true;
              }
              if(positionLength == 4 && this.num <=40){
                this.solo = true;
              }
              if(positionLength == 5 && this.num <= 100){
                this.solo = true;
              }
              break;
            }
            case '任选三组三':
            case '任选三组六':
            case '任选三混合组选':
            case '任选三组选和值':
            {
              if(positionLength == 3 && this.num <= 2){
                this.solo = true;
              }
              if(positionLength == 4 && this.num <= 8){
                this.solo = true;
              }
              if(positionLength == 5 && this.num <= 20){
                this.solo = true;
              }
              break;
            }
            case '任选四直选复式':
            case '任选四直选单式':
            {
              if(positionLength == 4 && this.num <= 100){
                this.solo = true;
              }
              if(positionLength == 5 && this.num <= 500){
                this.solo = true;
              }
              break;
            }
            case '任选四组选24':{
              if(positionLength == 4 && this.num <= 5){
                this.solo = true;
              }
              if(positionLength == 5 && this.num <= 25){
                this.solo = true;
              }
              break;
            }
            //例外规则
            case '五星组选120':
            {
              if(this.num <=6){
                this.solo = true;
              }
              break;
            }
            case '五星组选60':
            {
              if(this.num <=12){
                this.solo = true;
              }
              break;
            }
            case '五星组选30':{
              if(this.num <=30){
                this.solo = true;
              }
              break;
            }
            case '五星组选20':{
              if(this.num <=48){
                this.solo = true;
              }
              break;
            }
            case '五星组选5':
            case '五星组选10':{
              if(this.num <=45){
                this.solo = true;
              }
              break;
            }
            case '四星组选12':
            {
              if(this.num <= 9){
                this.solo = true;
              }
              break;
            }
            case '四星组选4':
            case '四星组选6':
            {
              if(this.num <= 24){
                this.solo = true;
              }
              break;
            }
            case '任选四组选12':{
              if(positionLength == 4 && this.num <=9){
                this.solo = true;
              }
              if(positionLength == 5 && this.num <=45){
                this.solo = true;
              }
              break;
            }
            case '任选四组选4':
            case '任选四组选6':
            {
              if(positionLength == 4 && this.num <=24){
                this.solo = true;
              }
              if(positionLength == 5 && this.num <=120){
                this.solo = true;
              }
              break;
            }
            case '龙虎斗龙虎斗':
            case '龙虎斗玄麟斗':
            case '龙虎斗万个':
            case '龙虎斗千十':
            case '龙虎斗万千':
            case '龙虎斗万百':
            case '龙虎斗万十':
            case '龙虎斗千百':
            case '龙虎斗千十':
            case '龙虎斗千个':
            case '龙虎斗百十':
            case '龙虎斗百个':
            case '龙虎斗十个':{
              if (this.num == 1 && this.bet.codes[0][0] == '和') {
                this.solo = true;
              }
            }
          }
        }
        //11x5
        if (_.includes(_11x5Alias, lotteryAlias)) {
          switch(methodName){
            case '三码前三直选复式':
            case '三码前三直选单式':{
              if (this.num <= 9 ) {
                this.solo = true;
              }
              break;
            }
            case '三码前三组选复式':
            case '三码前三组选单式':
            case '二码前二直选复式':
            case '二码前二直选单式':
            case '二码前二组选复式':
            case '二码前二组选单式':
            case '任选复式三中三':
            case '任选单式三中三':
            case '任选复式八中五':
            case '任选单式八中五':
            {
              if (this.num <= 1 ) {
                this.solo = true;
              }
              break;
            }
            case '任选复式四中四':
            case '任选单式四中四':
            case '任选复式七中五':
            case '任选单式七中五':{
              if(this.num <=3 ){
                this.solo = true;
              }
              break;
            }
            case '任选复式五中五':
            case '任选单式五中五':
            case '任选复式六中五':
            case '任选单式六中五':
            {
              if(this.num <= 4){
                this.solo = true;
              }
              break;
            }
          }
        }
        //3d 福彩 排列3
        if (_.includes(_3dAlias, lotteryAlias)) {
          switch(methodName){
            case '三码复式':
            case '三码直选和值':
            case '三码单式':{
              if (this.num <= 10 ) {
                this.solo = true;
              }
              break;
            }
            case '三码组三':
            case '三码组六':
            case '三码混合':
            case '二码后二直选复式':
            case '二码后二直选单式':
            case '二码前二直选复式':
            case '二码前二直选单式':
            case '二码后二组选复式':
            case '二码后二组选单式':
            case '二码前二组选复式':
            case '二码前二组选单式':
            {
              if(this.num <= 1){
                this.solo = true;
              }
              break;
            }
            case '三码组选和值':{
              if(this.num <= 2 ){
                this.solo = true;
              }
              break;
            }

          }
        }
        //pk10
        if (_.includes(pk10Alias, lotteryAlias)) {
          switch(methodName){
            case '前六复式':
            case '前六单式':{
              if (this.num <= 1500 ) {
                this.solo = true;
              }
              break;
            }
            case '前五复式':
            case '前五单式':{
              if (this.num <= 300 ) {
                this.solo = true;
              }
              break;
            }
            case '前四复式':
            case '前四单式':{
              if (this.num <= 50 ) {
                this.solo = true;
              }
              break;
            }
            case '前三复式':
            case '前三单式':{
              if (this.num <= 7 ) {
                this.solo = true;
              }
              break;
            }
            case '前二复式':
            case '前二单式':{
              if (this.num <= 1 ) {
                this.solo = true;
              }
              break;
            }
          }
        }
        //急速赛马
        if (_.includes(jssmAlias, lotteryAlias)) {
          switch(methodName){
            case '六连环复式':
            case '六连环单式':{
              if (this.num <= 1500 ) {
                this.solo = true;
              }
              break;
            }
            case '五连环复式':
            case '五连环单式':{
              if (this.num <= 300 ) {
                this.solo = true;
              }
              break;
            }
            case '四连环复式':
            case '四连环单式':{
              if (this.num <= 50 ) {
                this.solo = true;
              }
              break;
            }
            case '三连环复式':
            case '三连环单式':{
              if (this.num <= 7 ) {
                this.solo = true;
              }
              break;
            }
            case '连赢复式':
            case '连赢单式':{
              if (this.num <= 1 ) {
                this.solo = true;
              }
              break;
            }
          }
        }
        R.next();
      }
    },
    {
      // 0注数填充
      priority: 8850,
      condition: function(R) {
        R.when( _.isUndefined(this.num) );
      },
      consequence: function(R) {
        this.num = 0;
        R.next();
      }
    },
    {
      // 计算总投注金额
      priority: 8849,
      condition: function(R) {
        R.when( this.lotteryType === 'ssc' && !this.money )
      },
      consequence: function(R) {
        this.money = Number(_.round(this.num * (this.bet.times || 1) * this.bet.mode.rate * 2, 3));
        R.next();
      }
    },
    {
      // 倍数
      priority: 8848,
      condition: function(R) {
        R.when( this.lotteryType === 'ssc' && !this.times );
      },
      consequence: function(R) {
        this.times = (this.bet.times || 1);
        R.next();
      }
    },
    {
      // 资金模式
      priority: 8847,
      condition: function(R) {
        R.when( this.lotteryType === 'ssc' && !this.mode && this.currentMethod.modes && this.currentMethod.modes.length > 0);
      },
      consequence: function(R) {
        this.mode = _.find(this.currentMethod.modes, {rate: this.bet.mode.rate});
        R.next();
      }
    },
    {
      // 奖金模式
      priority: 8846,
      condition: function(R) {
        R.when( this.lotteryType === 'ssc' && !this.prize && this.currentMethod.prize && this.currentMethod.prize.length > 0);
      },
      consequence: function(R) {
        this.prize = this.bet.prize
        R.next();
      }
    },
    {
      // 任选位置
      priority: 8845,
      condition: function(R) {
        R.when( this.lotteryType === 'ssc' && this.currentMethod.selectarea.selPosition);
      },
      consequence: function(R) {
        this.poschoose = [];
        _.forEach(this.bet.poschoose, function(posBool, index){
          if (posBool) {
            this.poschoose.push(index + 1);
          }
        }.bind(this))
        this.poschoose = _.join(this.poschoose, ',')
      R.next();
      }
    },
    // 用于计算时时彩盈利的奖金组实际值
    {
      priority: 8800,
      condition: function(R) {
         R.when( this.lotteryType === 'ssc' && this.num )
      },
      consequence: function(R) {
        // 奖金组
        let prizeModes = [];
        // 奖金组为空的时候，使用奖级作为范围
        if (!this.currentMethod.prize) {
          prizeModes = [{option: 1, value: _.chain(this.currentMethod.level).map((item, index) => Number(_.values(item))).sortBy().value()}];
        }
        // 奖金组不为空，又不是范围的时候
        if (this.currentMethod.prize && !_.includes(this.currentMethod.prize[0].label, '~')) {
          prizeModes = _.chain(this.currentMethod.prize)
                        .map((item) => item.label.substring(3)
                        .split('-')
                        .map((it) => parseFloat(it)))
                        .map((item, index) => ({option: index + 1, value: [Number(item[0])]}))
                        .value()
        }
        // 奖金组不为空，奖金为范围区间的时候
        if (this.currentMethod.prize && _.includes(this.currentMethod.prize[0].label, '~')) {
          prizeModes = _.chain(this.currentMethod.prize)
                        .map((item, index) => ({option: index + 1, value: _.chain(item.label.split(' ')[1].split('~')).map((it) => Number(it)).sortBy().value()}))
                        .value()
        }
        this.currentPrizeModes = prizeModes;
        R.next();
      }
    },
    // 先通用性的计算出盈利，特殊玩法后续规则处理
    {
      priority: 8798,
      condition: function(R) {
         R.when( this.currentPrizeModes )
      },
      consequence: function(R) {
        const omodel = Number(this.prize) || 1;
        let arrPrizeModes = _.chain(this.currentPrizeModes)
                             .find({option: omodel})
                             .get('value')
                             .map((item) => _.round(item * _.find(this.currentMethod.modes, {modeid: this.mode.modeid}).rate * this.times, 4))
                             .value();
        this.currentPrize = arrPrizeModes.length > 1 ? _.head(arrPrizeModes)+'~'+_.last(arrPrizeModes) : _.head(arrPrizeModes);

        let arrBonus = _.chain(this.currentPrizeModes)
                             .find({option: omodel})
                             .get('value')
                             .map((item) => _.round(item * _.find(this.currentMethod.modes, {modeid: this.mode.modeid}).rate * this.times - this.money, 4))
                             .value();
        this.currentBonus = arrBonus.length > 1 ?  _.head(arrBonus)+'~'+_.last(arrBonus) : _.head(arrBonus);
        R.next();
      }
    },
    // 组合类，需要累计
    {
      priority: 8797,
      condition: function(R) {
         R.when( this.currentPrizeModes && _.includes(this.ruleSuite, 'combination'))
      },
      consequence: function(R) {
        const omodel = Number(this.prize) || 1;
        let arrPrizeModes = _.chain(this.currentPrizeModes)
                             .find({option: omodel})
                             .get('value')
                             .map((item) => _.round(item * _.find(this.currentMethod.modes, {modeid: this.mode.modeid}).rate * this.times, 4))
                             .value();
        this.currentPrize = _.head(arrPrizeModes)+'~'+ _.round(_.sum(arrPrizeModes), 4)
        this.currentBonus = _.round((_.head(arrPrizeModes) - this.money), 4) +'~'+ _.round(_.sum(arrPrizeModes) - this.money, 4)
        R.next();
      }
    },
    // 不定胆 && 趣味，按选中注数计算
    {
      priority: 8796,
      condition: function(R) {
         R.when( this.currentPrizeModes && (_.includes(['趣味', '不定胆', '龙虎斗'], this.currentCategory.name) ))
      },
      consequence: function(R) {
        switch(this.currentMethod.name){
          case '四星一码不定胆':
          case '五星一码不定胆':
          case '前三一码不定胆':
          case '中三一码不定胆':
          case '后三一码不定胆':
          case '前三位': {
            if (this.num == 2) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 2, 4)
            }
            if (this.num == 3) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 2 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
            }
            //仅用于前中后三
            if (this.num > 3 && this.currentMethod.name != '四星一码不定胆' && this.currentMethod.name != '五星一码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 2 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
            }
            //仅用于四五星
            if (this.num == 4 && (this.currentMethod.name == '四星一码不定胆' || this.currentMethod.name == '五星一码不定胆')) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
            }
            //仅用于四星
            if (this.num > 4 && this.currentMethod.name == '四星一码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
            }
            //仅用于五星
            if (this.num >= 5 && this.currentMethod.name == '五星一码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 4 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 5, 4)
            }
            break;
          }
          case '四星二码不定胆':
          case '五星二码不定胆':
          case '前三二码不定胆':
          case '中三二码不定胆':
          case '后三二码不定胆': {
            if (this.num == 3) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 2 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
            }
            //仅用于前中后三
            if (this.num > 3 && this.currentMethod.name != '四星二码不定胆' && this.currentMethod.name != '五星二码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 2 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
            }
            //仅用于四星
            if (this.num > 4 && this.currentMethod.name == '四星二码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 5 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 6, 4)
            }
            //仅用于五星
            if (this.num == 6 && this.currentMethod.name == '五星二码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 5 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 6, 4)
            }
            //仅用于五星
            if (this.num >= 10 && this.currentMethod.name == '五星二码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 9 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 10, 4)
            }
            break;
          }
          case '四星三码不定胆':
          case '五星三码不定胆': {
            //仅用于四星
            if (this.num >= 4 && this.currentMethod.name == '四星三码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
            }
            //仅用于五星
            if (this.num == 4 && this.currentMethod.name == '五星三码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
            }
            //仅用于五星
            if (this.num >= 10 && this.currentMethod.name == '五星三码不定胆') {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 9 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 10, 4)
            }
            break;
          }
          case '一帆风顺':{
            if (this.num > 1 && this.num <= 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * (this.num - 1) + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * this.num, 4)
            }
            if (this.num > 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 4 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 5, 4)
            }
            break;
          }
          case '好事成双':{
            if (this.num > 1) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 2, 4)
            }
            break;
          }
          case '龙虎斗':
          case '玄麟斗':{
            this.currentBonus = _.split(this.currentBonus, '~')[0];
            this.currentPrize = _.split(this.currentPrize, '~')[0];
            break;
          }
        }
        R.next();
      }
    },
    // 按位置任选, 11选5任选复式
    {
      priority: 8795,
      condition: function(R) {
         R.when( this.currentPrizeModes && (_.includes(['任选二', '任选三', '任选四'], this.currentCategory.name) ))
      },
      consequence: function(R) {
        const methodName = this.currentCategory.name + this.currentMethod.name;
        let poschooseNum;
        if (this.bet.poschoose) {
          poschooseNum = _.chain(this.bet.poschoose).filter((item) => item).value().length
        }else{
          poschooseNum = _.chain(this.formatCodes).filter((item) => item.length > 0).value().length;
        }
        switch(methodName){
          case '任选二直选复式':
          case '任选二直选和值': {
            if (poschooseNum == 3) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 2 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
            }
            if (poschooseNum == 4) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 5 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 6, 4)
            }
            if (poschooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 9 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 10, 4)
            }
            break;
          }
          case '任选二组选复式':{
            if (poschooseNum == 3) {
              if(this.formatCodes[0].length == 2){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize + this.currentBonus, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 2, 4)
              }
              if(this.formatCodes[0].length >= 3){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
              }
            }
            if (poschooseNum == 4) {
              if(this.formatCodes[0].length == 2){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 4 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
              }
              if(this.formatCodes[0].length == 3){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 5 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 5, 4)
              }
              if(this.formatCodes[0].length >= 4){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 6 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 6, 4)
              }
            }
            if (poschooseNum == 5) {
              if(this.formatCodes[0].length == 2){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 6 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 6, 4)
              }
              if(this.formatCodes[0].length == 3){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 8 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 8, 4)
              }
              if(this.formatCodes[0].length == 4){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 9 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 9, 4)
              }
              if(this.formatCodes[0].length >= 5){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 10 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 10, 4)
              }
            }
            break;
          }
          case '任选二组选和值':{
            if (poschooseNum == 3) {
              if(this.formatCodes[0].length == 1){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize + this.currentBonus, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 2, 4)
              }
              if(this.formatCodes[0].length >= 2){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
              }
            }
            if (poschooseNum == 4) {
              if(this.formatCodes[0].length == 1){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 4 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
              }
              if(this.formatCodes[0].length == 2){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 5 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 5, 4)
              }
              if(this.formatCodes[0].length >= 3){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 6 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 6, 4)
              }
            }
            if (poschooseNum == 5) {
              if(this.formatCodes[0].length == 1){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 5 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 5, 4)
              }
              if(this.formatCodes[0].length >= 2 && this.formatCodes[0].length <= 6){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 9 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 9, 4)
              }
              if(this.formatCodes[0].length >= 7){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 10 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 10, 4)
              }
            }
            break;
          }
          case '任选三直选复式':
          case '任选三直选和值': {
            if (poschooseNum == 4) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
            }
            if (poschooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 8 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 9, 4)
            }
            break;
          }
          case '任选三组三':{
            if (poschooseNum == 4) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
            }
            if (poschooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 8 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 9, 4)
            }
            break;
          }
          case '任选三组六':{
            if (poschooseNum == 4) {
              if(this.formatCodes[0].length == 3){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize + this.currentBonus, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 2, 4)
              }
              if(this.formatCodes[0].length >= 4){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 4 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
              }
            }
            if (poschooseNum == 5) {
              if(this.formatCodes[0].length == 3){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 + this.currentBonus, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
              }
              if(this.formatCodes[0].length == 4){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 7 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 7, 4)
              }
              if(this.formatCodes[0].length >= 5){
                this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 10 - this.money, 4)
                this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 10, 4)
              }
            }
            break;
          }
          case '任选三组选和值':{
            if (poschooseNum == 4) {
              if(this.formatCodes[0].length == 1){
                this.currentBonus = _.split(this.currentBonus,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 3 - this.money, 4)
                this.currentPrize = _.split(this.currentPrize,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 3, 4)
              }
              if(this.formatCodes[0].length >= 2){
                this.currentBonus = _.split(this.currentBonus,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 4 - this.money, 4)
                this.currentPrize = _.split(this.currentPrize,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 4, 4)
              }
            }
            if (poschooseNum == 5) {
              if(this.formatCodes[0].length == 1){
                this.currentBonus = _.split(this.currentBonus,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 6 - this.money, 4)
                this.currentPrize = _.split(this.currentPrize,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 6, 4)
              }
              if(this.formatCodes[0].length == 2){
                this.currentBonus = _.split(this.currentBonus,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 8 - this.money, 4)
                this.currentPrize = _.split(this.currentPrize,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 8, 4)
              }
              if(this.formatCodes[0].length >= 3){
                this.currentBonus = _.split(this.currentBonus,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 9 - this.money, 4)
                this.currentPrize = _.split(this.currentPrize,'~')[0] + '~' + _.round(_.split(this.currentPrize,'~')[1] * 9, 4)
              }
            }
            break;
          }
          case '任选四直选复式':{
            if (poschooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 4 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 5, 4)
            }
            break;
          }
          case '任选四组选24':
          case '任选四组选12':{
            if (poschooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 2, 4)
            }
            break;
          }
          case '任选四组选6':{
            if (poschooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 2 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
            }
            break;
          }
          case '任选四组选4':{
            if (poschooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
            }
            break;
          }

          case '任选二直选单式':
          case '任选二组选单式':
          case '任选三直选单式':
          case '任选三混合组选':
          case '任选四直选单式':{
            this.currentBonus = undefined;
            this.currentPrize = undefined;
            break;
          }
        }
        R.next();
      }
    },
    // 11选5，PK10定位胆
    {
      priority: 8794,
      condition: function(R) {
         R.when( this.currentPrizeModes && (_.includes(['定位胆', '位置'], this.currentCategory.name)) &&  _.includes(_.concat(pk10Alias, jssmAlias), this.currentCategory.flag) )
      },
      consequence: function(R) {
        const methodName = this.currentCategory.name + this.currentMethod.name;
        let poschooseNum;
        if (this.bet.poschoose) {
          poschooseNum = _.chain(this.bet.poschoose).filter((item) => item).value().length
        }else{
          poschooseNum = _.chain(this.formatCodes).filter((item) => item.length > 0).value().length;
        }
        switch(methodName){
          case '定位胆定位胆':
          case '定位胆1～10位定位胆':
          case '定位胆1～5位定位胆':
          case '定位胆6～10位定位胆':
          case '位置1～10位定位胆':
          case '位置1～5位位置':
          case '位置6～10位位置': {
            //const differenceNo = combinatorics.cartesianProduct(..._.filter(this.formatCodes, (item) => item.length > 0)).toArray();
            //let differenceNum = _.chain(differenceNo).map((item) => _.uniq(item).length).max().value();
            let differenceNum = [..._.filter(this.formatCodes, (item) => item.length > 0)].length;
            differenceNum = differenceNum > poschooseNum ? poschooseNum : differenceNum;
            if (differenceNum > 1) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * (differenceNum - 1) + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * differenceNum, 4)
            }
            break;
          }
        }
        R.next();
      }
    },
    // PK10,JSSM 大小单双
    {
      priority: 8793,
      condition: function(R) {
         R.when( this.currentPrizeModes && (_.includes(['大小单双'], this.currentCategory.name)) &&  _.includes(_.concat(pk10Alias, jssmAlias, sscAlias), this.currentCategory.flag) )
      },
      consequence: function(R) {
        const methodName = this.currentCategory.name + this.currentMethod.name;
        switch(methodName){
          case '大小单双总和':
          case '大小单双冠军':
          case '大小单双亚军':
          case '大小单双亚军':
          case '大小单双季军':
          case '大小单双前三和值':
          case '大小单双中三和值':
          case '大小单双后三和值': {
            const codeJoin = _.join(this.formatCodes[0], '');
            if (this.formatCodes[0].length > 1 && !_.includes(['大小','小大','单双','双单'], codeJoin)) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 2, 4)
            }
            break;
          }
          case '大小单双后二':
          case '大小单双前二': {
            const codeJoinCol1 = _.join(this.formatCodes[0], '');
            const codeJoinCol2 = _.join(this.formatCodes[1], '');
            let prizeNum = 0, prizeNum2 = 0;
            // 第一行
            if (this.formatCodes[0].length > 1 && !_.includes(['大小','小大','单双','双单'], codeJoinCol1)) {
              prizeNum += 2;
            }else{
              prizeNum ++;
            }
            // 第二行
            if (this.formatCodes[1].length > 1 && !_.includes(['大小','小大','单双','双单'], codeJoinCol2)) {
              prizeNum2 += 2;
            }else{
              prizeNum2 ++;
            }

            if (prizeNum * prizeNum2 > 1) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * (prizeNum * prizeNum2  - 1) + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * prizeNum * prizeNum2, 4)
            }
            break;
          }
          case '大小单双后三':
          case '大小单双前三': {
            const codeJoinCol1 = _.join(this.formatCodes[0], '');
            const codeJoinCol2 = _.join(this.formatCodes[1], '');
            const codeJoinCol3 = _.join(this.formatCodes[2], '');
            let prizeNum = 0, prizeNum2 = 0, prizeNum3 = 0;
            // 第一行
            if (this.formatCodes[0].length > 1 && !_.includes(['大小','小大','单双','双单'], codeJoinCol1)) {
              prizeNum += 2;
            }else{
              prizeNum ++;
            }
            // 第二行
            if (this.formatCodes[1].length > 1 && !_.includes(['大小','小大','单双','双单'], codeJoinCol2)) {
              prizeNum2 += 2;
            }else{
              prizeNum2 ++;
            }
            // 第三行
            if (this.formatCodes[2].length > 1 && !_.includes(['大小','小大','单双','双单'], codeJoinCol3)) {
              prizeNum3 += 2;
            }else{
              prizeNum3 ++;
            }
            if (prizeNum * prizeNum2 * prizeNum3 > 1) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * (prizeNum * prizeNum2 * prizeNum3  - 1) + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * prizeNum * prizeNum2 * prizeNum3, 4)
            }
            break;
          }
          case '大小单双前三大小个数':
          case '大小单双中三大小个数':
          case '大小单双后三大小个数': {
            const codeJoinCol = _.concat(...this.formatCodes);
            const codeJoin = _.join(codeJoinCol, '');
            if(this.num < 3 && _.includes(['全大','全小','全大全小'], codeJoin)){
              this.currentBonus = _.split(this.currentBonus, '~')[1];
              this.currentPrize = _.split(this.currentPrize, '~')[1];
            }
            if(this.num < 3 && _.includes(['2大1小','1大2小','1大2小2大1小'], codeJoin)){
                this.currentBonus = _.split(this.currentBonus, '~')[0];
                this.currentPrize = _.split(this.currentPrize, '~')[0];
            }
            break;
          }
          case '大小单双前三单双个数':
          case '大小单双中三单双个数':
          case '大小单双后三单双个数': {
            const codeJoinCol = _.concat(...this.formatCodes);
            const codeJoin = _.join(codeJoinCol, '');
            if(this.num < 3 && _.includes(['全单','全双','全单全双'], codeJoin)){
              this.currentBonus = _.split(this.currentBonus, '~')[1];
              this.currentPrize = _.split(this.currentPrize, '~')[1];
            }
            if(this.num < 3 && _.includes(['2单1双','1单2双','1单2双2单1双'], codeJoin)){
                this.currentBonus = _.split(this.currentBonus, '~')[0];
                this.currentPrize = _.split(this.currentPrize, '~')[0];
            }
            break;
          }
        }
        R.next();
      }
    },
    // 11选5任选
    {
      priority: 8792,
      condition: function(R) {
         R.when( this.currentPrizeModes && _.includes(['任选复式'], this.currentCategory.name) && _.includes(this.currentCategory.flag, '11x5'))
      },
      consequence: function(R) {
        const methodName = this.currentCategory.name + this.currentMethod.name;
        const chooseNum = this.formatCodes[0].length <= 5 ? this.formatCodes[0].length : 5;
        switch(methodName){
          case '任选复式一中一':{
            if (chooseNum > 1) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * (chooseNum - 1) + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * chooseNum, 4)
            }
            break;
          }
          case '任选复式二中二':{
            if (chooseNum == 3) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 2 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
            }
            if (chooseNum == 4) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 5 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 6, 4)
            }
            if (chooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 9 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 10, 4)
            }
            break;
          }
          case '任选复式三中三':{
            if (chooseNum == 4) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 4, 4)
            }
            if (chooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 9 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 10, 4)
            }
            break;
          }
          case '任选复式四中四':{
            if (chooseNum == 5) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 4 + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 5, 4)
            }
            break;
          }
          case '任选复式六中五':{
            if (this.formatCodes[0].length > 6) {
              this.currentBonus = _.round(this.currentPrize * (this.formatCodes[0].length - 6) + this.currentBonus, 4)
              this.currentPrize = _.round(this.currentPrize * (this.formatCodes[0].length - 5), 4)
            }
            break;
          }
          case '任选复式七中五':{
            if (this.formatCodes[0].length == 8) {
              this.currentBonus = _.round(this.currentPrize * 2 + this.currentBonus, 4)
              this.currentPrize = _.round(this.currentPrize * 3, 4)
            }
            if (this.formatCodes[0].length == 9) {
              this.currentBonus = _.round(this.currentPrize * 5 + this.currentBonus, 4)
              this.currentPrize = _.round(this.currentPrize * 6, 4)
            }
            if (this.formatCodes[0].length == 10) {
              this.currentBonus = _.round(this.currentPrize * 9 + this.currentBonus, 4)
              this.currentPrize = _.round(this.currentPrize * 10, 4)
            }
            if (this.formatCodes[0].length == 11) {
              this.currentBonus = _.round(this.currentPrize * 14 + this.currentBonus, 4)
              this.currentPrize = _.round(this.currentPrize * 15, 4)
            }
            break;
          }
          case '任选复式八中五':{
            if (this.formatCodes[0].length == 9) {
              this.currentBonus = _.round(this.currentPrize * 3 + this.currentBonus, 4)
              this.currentPrize = _.round(this.currentPrize * 4, 4)
            }
            if (this.formatCodes[0].length == 10) {
              this.currentBonus = _.round(this.currentPrize * 9 + this.currentBonus, 4)
              this.currentPrize = _.round(this.currentPrize * 10, 4)
            }
            if (this.formatCodes[0].length == 11) {
              this.currentBonus = _.round(this.currentPrize * 19 + this.currentBonus, 4)
              this.currentPrize = _.round(this.currentPrize * 20, 4)
            }
            break;
          }
        }
        R.next();
      }
    },
    // 3D排列三定位胆，不定胆
    {
      priority: 8792,
      condition: function(R) {
         R.when( this.currentPrizeModes && (_.includes(['定位胆','不定胆'], this.currentCategory.name)) &&  _.includes(_.concat(_3dAlias, _11x5Alias, sscAlias), this.currentCategory.flag) )
      },
      consequence: function(R) {
        const methodName = this.currentCategory.name + this.currentMethod.name;
        let poschooseNum;
        if (this.bet.poschoose) {
          poschooseNum = _.chain(this.bet.poschoose).filter((item) => item).value().length
        }else{
          poschooseNum = _.chain(this.formatCodes).filter((item) => item.length > 0).value().length;
        }
        switch(methodName){
          case '定位胆定位胆': {
            if (poschooseNum > 1) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * (poschooseNum - 1) + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * poschooseNum, 4)
            }
            break;
          }
          case '不定胆一码不定胆':{
            if (this.formatCodes[0].length > 1) {
              const times = this.formatCodes[0].length > 3 ? 3 : this.formatCodes[0].length;
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * (times - 1) + this.currentBonus, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * times, 4)
            }
            break;
          }
        }
        R.next();
      }
    },
    // 快三
    {
      priority: 8791,
      condition: function(R) {
         R.when( this.currentPrizeModes && (_.includes(['二不同号'], this.currentCategory.name)) &&  _.includes(k3Alias, this.currentCategory.flag) )
      },
      consequence: function(R) {
        const methodName = this.currentCategory.name + this.currentMethod.name;
        switch(methodName){
          case '二不同号标准选号': {
            if (this.formatCodes[0].length >= 3) {
              this.currentBonus = this.currentBonus + '~' + _.round(this.currentPrize * 3 - this.money, 4)
              this.currentPrize = this.currentPrize + '~' + _.round(this.currentPrize * 3, 4)
            }
            break;
          }
        }
        R.next();
      }
    },
    // 时时彩不计算盈利的玩法
    {
      priority: 8790,
      condition: function(R) {
         R.when( this.currentPrizeModes && this.lotteryType === 'ssc')
      },
      consequence: function(R) {
        const methodName = this.currentCategory.name + this.currentMethod.name;
        let disabled = false;
        // 单式屏蔽
        if (_.includes(methodName, '单式')) {
          disabled = true;
        }
        // PK10 JSSM
        if (_.includes(_.concat(pk10Alias, jssmAlias), this.currentCategory.flag)) {
          const disabledMethods = ['竞速竞速', '对决对决'];
          if (_.includes(disabledMethods, methodName)) {
            disabled = true;
          }
        }
        // 不计算盈利的，打标识
        if (disabled) {
          this.currentBonus = undefined;
          this.currentPrize = undefined;
        }
        R.next();
      }
    },
    // 用于计算六合彩盈利的奖金组实际值
    // {
    //  priority: 8700,
    //  condition: function(R) {
    //      R.when( this.lotteryType === 'lhc' )
    //   },
    //   consequence: function(R) {
    //    if (_.filter(this.bet.codes, (item) => item.value > 0).length > 0) {
    //      const sumMoney = _.sum(_.filter(this.bet.codes, (item) => item.value > 0).map((it) => Number(it.value)));
    //      const maxTimes = _.maxBy(_.filter(this.bet.codes, (item) => item.value > 0), 'value');
    //      const minTimes = _.minBy(_.filter(this.bet.codes, (item) => item.value > 0), 'value');
    //      const prizeModes = _.union([maxTimes, minTimes]);
    //      this.currentPrize = _.chain(prizeModes)
    //                           .map((item) =>  _.round(item.value * _.find(this.currentMethod.prize, {value: Number(this.bet.prize)}).label.split(' ')[1].split('-')[0], 4))
    //                           .join('~')
    //                           .value();
    //      this.currentBonus = _.chain(prizeModes)
    //                           .map((item) => _.round(item.value * _.find(this.currentMethod.prize, {value: Number(this.bet.prize)}).label.split(' ')[1].split('-')[0] - sumMoney, 4))
    //                           .join('~')
    //                           .value();
    //    }else{
    //      this.currentPrize = 0;
    //      this.currentBonus = 0;
    //    }
    //    R.next();
    //   }
    // },
    // 没有注数，盈利undefined填充
    {
      priority: 8600,
      condition: function(R) {
         R.when( !this.currentPrizeModes )
      },
      consequence: function(R) {
        this.currentPrize = undefined;
        this.currentBonus = undefined;
        R.next();
      }
    }
  ]

}